var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"social-link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.fortAwesomeIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }